<template>
  <section class="pt-8 px-3 mb-8">
    <h1 class="text-center mb-7 font-size--20 font-weight-black">상품 소개</h1>

    <div class="item">
      <v-layout justify-center align-center>
        <span class="item__title">대출 종류</span>
        <v-divider vertical></v-divider>
        <div class="item__content">
          <p>펀다x중소벤처기업부 제공 (이자액 환급 대출)</p>
          <p class="emphasis">중금리 무이자 대출</p>
        </div>
      </v-layout>
    </div>

    <div class="item">
      <v-layout justify-center align-center>
        <span class="item__title">최대 한도</span>
        <v-divider vertical></v-divider>
        <div class="item__content">
          <p class="emphasis">2,000만원</p>
          <p>평균 1,000만원 대출 가능</p>
        </div>
      </v-layout>
    </div>

    <div class="item">
      <v-layout justify-center align-center>
        <span class="item__title">이자액</span>
        <v-divider vertical></v-divider>
        <div class="item__content">
          <p>1,000만원 대출 시, <span class="emphasis">22~27만원</span></p>
          <p>계약 금리 연 11%, 실질 부담 이율 2.2~2.7%</p>
        </div>
      </v-layout>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
  color: #333;
  font-size: 13px;
}
.emphasis {
  font-size: 20px;
  font-weight: 900;
}

.item {
  border-radius: 8px;
  box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
  background-color: white;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  &__title {
    min-width: 100px;
    width: 30%;
    text-align: center;
    padding: 16px;
    color: #757575;
    font-size: 16px;
    font-weight: 900;
  }

  .v-divider {
    height: 40px;
    margin: auto;
  }

  &__content {
    word-spacing: -1px;
    min-width: 100px;
    width: 70%;
    padding: 16px;
    line-height: 1.4;
  }
}
</style>
